<div class="bo-dialog">
  <header class="bo-dialog__head">
  <span class="bo-dialog__icon"><i class="bi bi-currency-exchange" aria-hidden="true"></i></span>
  <div class="bo-dialog__heading"><h2 id="currency-title">{{ modalTitle | translate }}</h2></div>
  <button type="button" class="bo-dialog__close" [attr.aria-label]="'ac_close' | translate"  (click)="activeModal.dismiss()"><i class="bi bi-x-lg" aria-hidden="true"></i></button>
</header>

  <div class="bo-dialog__body">
    <app-dynamic-select-input [itemsList]="dataObject" [selectedItems]="selectedObject"
      [defaultBindLabel]="labelReference" [bindId]="'id'" [label]="'sh_setting_select_currency'" [multiple]="false"
      [showCloseButton]="false" [hasSymbol]="true" (newSelectEvent)="onSelectCurrency($event)">
    </app-dynamic-select-input>

    <!-- Warning message for currency changes -->
    <div class="bo-dialog__notice bo-dialog__notice--warning mt-3" role="alert"
      *ngIf="modalTitle === 'sh_setting_change_shop_currency' || modalTitle === 'sh_setting_add_currency'">
      <i class="bi bi-exclamation-triangle-fill me-2"></i>
      <span>{{ 'sh_currency_change_warning' | translate }}</span>
    </div>
  </div>

  <div class="bo-dialog__foot">
    <button type="button" class="bo-dialog__button" (click)="activeModal.dismiss()">
      {{ "ac_cancel" | translate }}
    </button>

    <!-- Change button for change currency modal -->
    <button type="button" class="bo-dialog__button bo-dialog__button--primary" (click)="activeModal.close(selectedCurrency)"
      *ngIf="modalTitle === 'sh_setting_change_shop_currency'">
      <i class="bi bi-arrow-repeat me-1"></i>
      {{ "ac_change" | translate }}
    </button>

    <!-- Add button for add currency modal -->
    <button type="button" class="bo-dialog__button bo-dialog__button--primary" (click)="activeModal.close(selectedCurrency)"
      *ngIf="modalTitle === 'sh_setting_add_currency'">
      <i class="bi bi-plus-lg me-1"></i>
      {{ "ac_add" | translate }}
    </button>
  </div>
</div>